export function obterCategoriaDocumento(campo, enviado) {
  const statusLabel = enviado ? "Enviado" : "Pendente";
  if (campo?.startsWith("checklist_")) {
    return {
      label: "Checklist",
      chipColor: "primary",
      badgeColor: "primary",
      borderColor: "primary.main",
      statusLabel,
      statusColor: enviado ? "success" : "warning",
      ariaLabel: `Checklist, ${statusLabel.toLowerCase()}`,
    };
  }
  if (campo?.startsWith("analista_")) {
    return {
      label: "Analista",
      chipColor: "success",
      badgeColor: "success",
      borderColor: "success.main",
      statusLabel,
      statusColor: enviado ? "success" : "warning",
      ariaLabel: `Analista, ${statusLabel.toLowerCase()}`,
    };
  }
  if (campo?.startsWith("solicitacao_")) {
    return {
      label: "Solicitação",
      chipColor: "info",
      badgeColor: enviado ? "success" : "warning",
      borderColor: enviado ? "success.main" : "warning.main",
      statusLabel,
      statusColor: enviado ? "success" : "warning",
      ariaLabel: `Solicitação, ${statusLabel.toLowerCase()}`,
    };
  }
  return null;
}
